export const completedValues = ['DELIVERY_COMPLETED', 'PICKUP_COMPLETE'];
export const cancelledValues = ['CANCELLED'];
